<template>
  <TolgeeProvider>
    <ConfigProvider>
      <UIToaster />
      <v-app v-auto-translate>
        <Loader />
        <router-view />
      </v-app>
    </ConfigProvider>
  </TolgeeProvider>
</template>

<script lang="ts" setup>
import Loader from '@/components/Shared/Loader.vue'
import {
  initializeSupportChatWidget,
  teardownSupportChatWidget,
} from '@/helpers/supportChatWidget'
import { TolgeeProvider } from '@tolgee/vue'
import { ConfigProvider } from 'radix-vue'

defineOptions({ name: 'App' })

const { profile } = storeToRefs(useAuthStore())
const utils = useUtilsStore()

const openModal = ref(false)

watch(
  profile,
  (currentUser) => {
    if (!currentUser?.id) {
      teardownSupportChatWidget()
      return
    }

    openModal.value = !currentUser.updated_default_password
    void initializeSupportChatWidget(currentUser)
  },
  { immediate: true },
)

onUnmounted(() => {
  teardownSupportChatWidget()
})

onMounted(async () => {
  const [brands, models] = await Promise.all([
    fetchVehicleBrands(),
    getVehicleModelsQuery(),
  ])

  if (Array.isArray(brands?.data)) {
    utils.setVehicleBrands(brands.data)
  }

  if (Array.isArray(models?.data)) {
    utils.setVehicleModels(models.data)
  }
})
</script>
